export enum PricingStack {
    HighDemand = 'highdemand',
    MsrpPrice = 'msrp',
    AutonationPrice = 'autonationprice',
    PendingSale = 'pendingsale',
    CallForPrice = 'callforprice'
}